// 开发环境域名
//const host_development = 'http://localhost'
const host_development = 'https://www.muhe.cc'

export default {
    // 版本
    version: '3.4.0',
    baseURL: process.env.NODE_ENV == 'production' ? '' : host_development,
    tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW'
}
